import iconDownload from '@assets/icons/icon-download.svg';
import { ButtonType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends ButtonType {}

const Button: React.FC<Props> = ({
  title,
  href = '#',
  className = '',
  type = 'link',
  selected = false,
  onClick = () => {},
  icon,
  target = '_self',
  ...props
}) => {
  const classes =
    'button-component bg-red rounded-lg inline-block py-3 px-4 lg:px-6 font-bold text-white mt-6 text-center transition-opacity duration-500 hover:opacity-50 leading-tight select-none';

  if (type === 'button') {
    return (
      <button
        className={classNames('', classes, className, {
          '!bg-blue !text-white': selected,
          'flex justify-between gap-2': icon,
        })}
        onClick={onClick}
        {...props}
      >
        {title}
        {icon === 'download' && <img src={iconDownload} alt={icon} />}
      </button>
    );
  }

  if (type === 'submit') {
    return (
      <button
        className={classNames('', classes, className)}
        onClick={onClick}
        {...props}
      >
        {title}
      </button>
    );
  }

  return (
    <a
      href={href}
      className={classNames('', classes, className)}
      target={target}
    >
      {title}
    </a>
  );
};

export default Button;
